module.exports = __webpack_public_path__ + "static/media/9.44555990.JPG";